<template>
  <div>
    <qx-card title="客户线路信息" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <qx-detail-box
        v-for="(data, index) in detailData"
        :data="data"
        :key="index"
      >
        <section slot="lineInfo">111</section>
      </qx-detail-box>
      <!-- 订单详情数据 end -->
    </qx-card>
    <!-- <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="100000"
      :inFast="Boolean(id)"
    />-->
  </div>
</template>

<script>
import {
  cityCustomerLineQueryByLineId, // 获取详情
} from 'api/distribution';
// import ApproveBox from 'components/approveBox';
export default {
  // components: {
  // ApproveBox,
  // },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      detailData: {
        base: {
          label: '客户信息',
          tableData: {
            title: [
              { prop: 'customerName', label: '客户名称' },
              { prop: 'lineName', label: '联系人' },
              { prop: 'lineTel', label: '联系人手机' },
              { prop: 'orgName', label: '归属部门' },
              { prop: 'effectBegin', label: '生效日期' },
              { prop: 'effectEnd', label: '有效期至' },
              { prop: 'customerLineNo', label: '客户线路编码' },
              // { prop: 'customerDetail', label: '客户信息', slot: true, span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        goods: {
          label: '车型及货物信息',
          tableData: {
            title: [
              { prop: 'vehicleInfo', label: '车型要求' },
              { prop: 'goodsWeight', label: '重量', unit: '吨' },
              { prop: 'goodsVolume', label: '容积', unit: '立方' },
              { prop: 'lineStsName', label: '货品类型' },
              { prop: 'goodsName', label: '货品名称' },
              { prop: 'tempInfo', label: '温控要求' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        line: {
          label: '线路信息',
          tableData: {
            title: [
              { prop: 'sourceAddress', label: '出发地址' },
              { prop: 'sourceAddressNavigation', label: '导航地址' },
              { prop: 'targetCity', label: '目的城市' },
              { prop: 'lineCodeName', label: '线路名称' },
              { prop: 'distributionDistrict', label: '配送区县', span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        income: {
          label: '收入信息',
          tableData: {
            title: [
              { prop: 'incomeChargeModeName', label: '计费方式' },
              { prop: 'incomeBasic', label: '基本运费', unit: '元' },
              { prop: 'incomeBasicCount', label: '基本点数' },
              { prop: 'incomeRegionalCost', label: '点费', unit: '元/个' },
              { prop: 'incomeDistributionDistrict', label: '超区区县', span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        cost: {
          label: '成本信息',
          tableData: {
            title: [
              { prop: 'oilCostPer', label: '载重油耗', unit: '升/百公里' },
              { prop: 'pontagePer', label: '路桥费', unit: '元/百公里' },
              { prop: 'emptyOilCostPer', label: '空载油耗', unit: '升/百公里' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        outward: {
          label: '外调车承包车成本收起',
          tableData: {
            title: [
              { prop: 'costChargeModeName', label: '计费方式' },
              { prop: 'costBasic', label: '基本运费', unit: '元' },
              { prop: 'costBasicCount', label: '基本点数' },
              { prop: 'costRegionalCost', label: '点费', unit: '元/个' },
              { prop: 'costDistributionDistrict', label: '超区区县', span: 1 },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        settlement: {
          label: '结算信息',
          tableData: {
            title: [
              {
                prop: 'payWayName',
                label: '结算方式',
              },
              {
                prop: 'reciveTime',
                label: '回单期限',
              },
              {
                prop: 'collection',
                label: '收款期限',
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        remark: {
          label: '备注说明',
          tableData: {
            title: [
              { prop: 'remarks', label: '操作说明' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    async getData () {
      if (this.$route.path !== '/manage/distribution/customerLine/detail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await cityCustomerLineQueryByLineId({
        lineId: this.id || this.$route.query.id,
      });
      this.loading = false;
      if (!detailRes.failed) {
        detailRes.vehicleInfo = `${detailRes.vehicleStatus || '-'}/${detailRes.vehicleLength + '米' || '-'}`;
        detailRes.tempInfo = `${detailRes.tempTypeName}${detailRes.tempStart !== undefined ? (detailRes.tempStart + '度') : '-'} 至 ${detailRes.tempEnd !== undefined ? (detailRes.tempEnd + '度') : '-'}`;
        detailRes.targetCity = '';
        detailRes.distributionDistrict = '';
        if (detailRes.subLinaArea && detailRes.subLinaArea.length) {
          let targetCityList = [];
          let distributionDistrictList = [];

          let incomeDistributionDistrictList = [];
          let costDistributionDistrictList = [];

          for (let i = 0; i < detailRes.subLinaArea.length; i++) {
            const item = detailRes.subLinaArea[i];
            if (item.lineType === 0) {
              targetCityList.push(item.desProvinceName + item.desCityName);
              distributionDistrictList.push(item.desProvinceName + item.desCityName + item.desCountyName);
            }
            if (item.lineType === 1) {
              // 收入 - 超区区县
              incomeDistributionDistrictList.push(item.desProvinceName + item.desCityName + item.desCountyName + `（超区费用：${item.superzoneFee}元）`);
            }
            if (item.lineType === 2) {
              // 支出 - 超区区县
              costDistributionDistrictList.push(item.desProvinceName + item.desCityName + item.desCountyName + `（超区费用：${item.superzoneFee}元）`);
            }
          }
          detailRes.targetCity = targetCityList.join('，');
          detailRes.distributionDistrict = distributionDistrictList.join(' - ');

          detailRes.incomeDistributionDistrict = incomeDistributionDistrictList.join('，');
          detailRes.costDistributionDistrict = costDistributionDistrictList.join('，');
        }

        if (detailRes.effectBegin) {
          detailRes.effectBegin = this.formatDate(detailRes.effectBegin);
        }
        if (detailRes.effectEnd) {
          detailRes.effectEnd = this.formatDate(detailRes.effectEnd);
        }

        this.detailData.settlement.tableData.title = [
          { prop: 'payWayName', label: '结算方式' },
        ];
        if (detailRes.payWay === 1) {
          this.detailData.settlement.tableData.title.push(...[{
            prop: 'reciveTimeStr',
            label: '回单期限',
          }]);
        } else if (detailRes.payWay === 2 || detailRes.payWay === 3) {
          this.detailData.settlement.tableData.title.push(...[{
            prop: 'reciveTimeStr',
            label: '回单期限',
          }, {
            prop: 'collectionTimeStr',
            label: '收款期限',
          }]);
        }
        for (let item in this.detailData) {
          if (this.detailData[item]) {
            this.detailData[item].tableData.data = detailRes;
          }
        }
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.orderStatusBox {
  overflow: auto;
}
.orderInfoBox {
  margin: 16px 12px 0;
  min-height: 124px;
  border: 1px solid $border-color;
  padding: 24px 16px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    height: 16px;
    line-height: 16px;
    padding-bottom: 16px;
  }
  .desc,
  .time {
    color: #666;
    line-height: 16px;
  }
  .desc {
    padding-bottom: 12px;
  }
}
.box {
  border-top: 1px solid $border-color;
  border-left: 1px solid $border-color;
  border-right: 1px solid $border-color;
}
.itemLabel {
  background: $grey;
}
.itemLabel,
.itemText {
  height: 48px;
  line-height: 48px;
  padding: 0 24px;
  box-sizing: border-box;
  border-bottom: 1px solid $border-color;
}
</style>
